import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {USER_TABS} from 'src/constants';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';

import {useGateValue} from '@pb/kit-lib-statsig';

import {UserEntitlementsSubTab} from './assigned/user-entitlements-subtab';
import {ENTITLEMENTS_SUB_TABS} from './constants';
import {DatasetEntitlementsSubTab} from './dataset/dataset-entitlements-subtab';
import {McpUserEntitlementsSubTab} from './mcp/mcp-user-entitlements-subtab';

type Props = {
    userId: number,
    accountId: number,
};

export const EntitlementsWrapper = ({userId, accountId}: Props) => {
    const isDatasetEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);
    return (
        <Routes>
            <Route
                path={`/${ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS.name}`}
                element={<UserEntitlementsSubTab userId={userId} accountId={accountId}/>}
            />
            <Route
                path={`/${ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}`}
                element={<McpUserEntitlementsSubTab userId={userId} accountId={accountId}/>}
            />
            {isDatasetEnabled ? (
                <Route
                    path={`/${ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}`}
                    element={<DatasetEntitlementsSubTab userId={userId}/>}
                />
            ) : null}
            <Route
                path="*"
                element={(
                    <Navigate
                        to={
                            `/profile/user/${userId}/` +
                            `${USER_TABS.ENTITLEMENTS.name}/` +
                            `${ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS.name}`
                        }
                    />
                )}
            />
        </Routes>
    );
};
